<template>
  <section class="registrationPrompt__Inner">
    <p class="registrationPrompt__Route">
      {{ $store.getters.getStringTranslation('dontHaveAcc') }}

      <router-link
        :to="{
          name: 'Register',
          query: { api_keys: JSON.stringify(['bee095f2-1525-477f-bc90-640a3e41a8de']) },
        }"
        >{{ $store.getters.getStringTranslation('register') }}</router-link
      >
    </p>

    <h1 class="registrationPrompt__Title">{{ $store.getters.getStringTranslation('signInMotyro') }}</h1>
    <p class="registrationPrompt__Lead">{{ $store.getters.getStringTranslation('enterDetails') }}</p>

    <form @submit.prevent="login()">
      <p>
        <label class="formLabel" for="email">{{ $store.getters.getStringTranslation('email') }}</label>
        <input class="formInput" v-model="loginData.email" type="email" id="email" />
      </p>

      <p>
        <label class="formLabel" for="password">{{ $store.getters.getStringTranslation('password') }}</label>
        <input class="formInput" v-model="loginData.password" type="password" id="password" />
      </p>

      <p class="message">
        {{ $store.getters.getStringTranslation('cookiesMessage') }}
      </p>
      <p v-if="error.text !== ''" class="message--Important" v-html="error.text"></p>

      <div class="registrationPrompt__Submit">
        <p>
          <router-link :to="{ name: 'Reset' }">{{ $store.getters.getStringTranslation('forgotPass') }}</router-link>
        </p>
        <p>
          <button class="button--Registration" type="submit">
            {{ $store.getters.getStringTranslation('signIn') }}
          </button>
        </p>
      </div>
    </form>
    <loader class="imageLoader" :loading="loading" />
  </section>
</template>

<script>
import HTTP from '@/http-common.js'

import Loader from '@/components/partials/Loader.vue'

export default {
  name: 'Login',
  components: {
    Loader,
  },
  data() {
    return {
      loginData: {
        email: '',
        password: '',
      },
      loading: false,
      error: {
        text: '',
        status: '',
      },
    }
  },
  methods: {
    login() {
      this.loading = true
      HTTP.post('login', this.loginData)
        .then((response) => {
          localStorage.setItem('token', response.data.token)
          this.$store.dispatch('updateUser', response.data)
          this.$router.push({ name: 'Dashboard' })
          this.loading = false
        })
        .catch((e) => {
          if (this.error.status === e.response.status) {
            this.error.text = 'Sorry, still no luck. Have you tried resetting your password?'
          } else if (e.response.status === 401) {
            this.error.text = 'Whoops. Wrong username/password!'
          } else {
            this.error.text = e.response.statusText
          }
          this.error.status = e.response.status
          this.loading = false
        })
    },
  },
  mounted() {
    this.$store.dispatch('updateUser', {})
    this.$store.dispatch('updateOrg', {})
  },
}
</script>
